/**
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 */

 import ServicePath from "@/core/ServicePath"
 import { MainRequest } from "@/core/request";

 export default class TemplateRequest extends MainRequest{

     static listAllTemplate() {
        return this.getSEC(ServicePath.TEMPLATE_HTML_LIST);
     }

     static addLogoTemplate(data) {
         return this.postSEC(ServicePath.LOGO_TEMPLATE_ADD, data);
     }
     
     static addLogos(data){
        return this.postSEC(ServicePath.LOGO_ADD, data);
     }

     static listLogos(){
        return this.getSEC(ServicePath.LOGO_LIST);
     }
   
     static deleteLogo(data){
        return this.postSEC(ServicePath.LOGO_DELETE,data);
     }
     static templatesByLogo(data){
      return this.postSEC(ServicePath.LOGO_BY_TEMPLATES,data);
     }

 }